import { Form, Input, message, Modal, Select } from 'antd';
import { startCase } from 'lodash';
import React, { useState } from 'react';

import { fetchAPI } from '../../utils/api';
import { OrderOperationStatus, OrderShippingStatus } from './utils';

const OrderShipmentStatus = ({ record, onSuccess }) => {
  const [modalState, setModalState] = useState({
    visible: false,
    status: '',
    remarks: '',
  });
  const [loading, setLoading] = useState(false);

  const changeDeliveryStatus = async () => {
    setLoading(true);
    try {
      await fetchAPI(`orders/${record.id}/set-shipping-status/action`, {
        method: 'POST',
        payload: {
          status: modalState.status,
          remarks: modalState.remarks,
        },
      });
      setModalState(ms => ({ ...ms, visible: false }));
      setLoading(false);
      onSuccess();
      message.success('Delivery Status Changed!');
    } catch (error) {
      message.error('Failed to change delivery status');
      if (error.message) {
        message.error(error.message);
      }
      setLoading(false);
    }
  };

  if (record.operation_status !== OrderOperationStatus.PENDING_DELIVERY) {
    return null;
  }

  return (
    <>
      <p style={{ margin: '10px 0 3px' }}>Delivery Status</p>
      <Select
        value={record.shipping_status || undefined}
        style={{ minWidth: 205 }}
        placeholder="Set Delivery Status"
        onChange={value =>
          setModalState(ms => ({
            ...ms,
            visible: true,
            status: value,
            remarks: '',
          }))
        }
      >
        {/* {Object.values(OrderShippingStatus).map((shipmentStatus, idx) => (
          <Select.Option value={shipmentStatus} key={idx}>
            {startCase(shipmentStatus)}
          </Select.Option>
        ))} */}
        {[
          OrderShippingStatus.OrderCreated,
          OrderShippingStatus.PickedUpFromMerchant,
          OrderShippingStatus.ParcelProcessing,
          OrderShippingStatus.InTransit,
        ].map((shipmentStatus, idx) => (
          <Select.Option value={shipmentStatus} key={idx}>
            {startCase(shipmentStatus)}
          </Select.Option>
        ))}
      </Select>
      <Modal
        visible={modalState.visible}
        onCancel={() => setModalState(ms => ({ ...ms, visible: false }))}
        title={`Change Delivery Status to ${startCase(modalState.status)}`}
        onOk={() => changeDeliveryStatus()}
        confirmLoading={loading}
      >
        {/* <Form.Item label="SPID">
          <Input value={record.spid} disabled />
        </Form.Item> */}
        <Form.Item label="Remarks">
          <Input
            value={modalState.remarks}
            onChange={e => {
              e.persist();
              setModalState(ms => ({ ...ms, remarks: e.target?.value }));
            }}
          />
        </Form.Item>
      </Modal>
    </>
  );
};

export default OrderShipmentStatus;
